import React, { useState, Fragment, useEffect, useMemo, useCallback, useRef } from "react"
import PropTypes from "prop-types"
import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
} from "reactstrap"
import { Link } from "react-router-dom"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  CSVExport,
} from "react-bootstrap-table2-toolkit"
import RestorePasswordModal from "../Users/RestorePasswordModal"
import avatar1 from "../../assets/images/user_without_pic.png"
import moment from "moment"
import SweetAlert from "react-bootstrap-sweetalert"
import ActivationDeactivationModal from "../Users/ActivationDeactivationModal"
import {
  userForgetPassword,
  userForgetPasswordClean,
  changePassword,
  changePasswordClean,
  activateDeactivate,
  activateDeactivateClean,
  getUsers,
  resetGroupUser,
  resetGroupUserClean,
  sendUserToTrash,
  sendUserToTrashClean,
  getUser,
  getUserClean,
  restoreUser,
  restoreUserClean,
} from "../../store/actions"
import "../../assets/scss/datatables.scss"
import { useDispatch, useSelector } from "react-redux"
import XlsExporter from "components/Common/XlsExporter"
import { numberWithCommas } from "common/strings"
import { getSoftskillsProfileName } from "pages/SoftSkills/Helpers/Helpers"

const HubUsersListTable = props => {
  const dispatch = useDispatch()

  const [dropDown, setDropDown] = useState(0)
  const [user, setUser] = useState({
    idUsuario: 0,
    email: "",
  })
  const [userForResetCourses, setUserForResetCourses] = useState(undefined)
  const [forgetPasswordSent, setForgetPasswordSent] = useState(false)
  const [changePasswordSent, setChangePasswordSent] = useState(false)
  const [activationType, setActivationType] = useState(undefined)
  const [page, setPage] = useState(undefined)
  const [filteredUsers, setFilteredUsers] = useState([])
  const [trash, setTrash] = useState(undefined)
  const [untrash, setUntrash] = useState(undefined)
  const [sizePerPage, setSizePerPage] = useState(undefined)
  const [searchText, setSearchText] = useState("")
  const debounceRef = useRef(null)
  const toolkitSearchRef = useRef(null)
  const [passwordView, setPasswordView] = useState(false)
  const [dependients, setDependients] = useState(false)
  const [activationDeactivationUser, setActivationDeactivationUser] =
    useState(0)

  const [showTrashUsers, setShowTrashUsers] = useState(false)

  const {
    error,
    loading,
    done,
    users,
    userWithDependients,
    forgetSuccess,
    forgetError,
    changePasswordError,
    changePasswordLoading,
    changePasswordSuccess,
    activateDeactivateLoading,
    activateDeactivateSuccess,
    resetDone,
    whoIAm,
    whoIAmNew,
    trashDone,
    restoreDone,
  } = useSelector(state => ({
    forgetSuccess: state.ForgetPassword.forgetSuccessMsg,
    forgetError: state.ForgetPassword.forgetError,
    changePasswordError: state.UsersList.changePasswordError,
    changePasswordLoading: state.UsersList.changePasswordLoading,
    changePasswordSuccess: state.UsersList.changePasswordSuccess,
    activateDeactivateLoading: state.UserEdit.activateDeactivateLoading,
    activateDeactivateSuccess: state.UserEdit.activateDeactivateSuccess,
    error: state.UsersList.error,
    loading: state.UsersList.loading,
    users: state.UsersList.users,
    userWithDependients: state.UserEdit.user,
    done: state.UsersList.done,
    resetDone: state.GroupUserReset.done,
    whoIAm: state.Profile.user,
    trashDone: state.UsersList.trashDone,
    restoreDone: state.UsersList.restoreDone,
    whoIAmNew: state.Profile.userNew,
  }))

  const userId = whoIAm?.idUsuario ?? 0
  const profileId = whoIAm?.idRol ?? 0
  const profileCmo = whoIAmNew?.cmoProfileId ?? 0
  const profileSS = whoIAmNew?.softskillsProfileId ?? 0

  useEffect(() => {
    if (userId !== 0) {
      dispatch(getUsers(userId, showTrashUsers))
    }
  }, [userId, showTrashUsers])

  useEffect(() => {
     if (!Array.isArray(users)) {
      setFilteredUsers(users)
      return
    }
    // Dedupe defensivo por userId: el backend puede devolver el mismo
    // usuario más de una vez (p. ej. sincronización con CMO). Conservamos
    // la primera aparición de cada userId para evitar filas duplicadas.
    const seen = new Set()
    const dedupedUsers = users.filter(user => {
      if (seen.has(user.userId)) {
        return false
      }
      seen.add(user.userId)
      return true
    })
    setFilteredUsers(dedupedUsers)
  }, [users])

  useEffect(() => {
    if (forgetSuccess) {
      setForgetPasswordSent(true)
      dispatch(userForgetPasswordClean())
    }
  }, [forgetSuccess])

  useEffect(() => {
    if (changePasswordSuccess) {
      setChangePasswordSent(true)
      dispatch(changePasswordClean())
    }
  }, [changePasswordSuccess])

  useEffect(() => {
    if (resetDone) {
      dispatch(resetGroupUserClean())
    }
  }, [resetDone])

  useEffect(() => {
    if (
      activateDeactivateSuccess &&
      activationDeactivationUser !== 0 &&
      userId !== 0
    ) {
      setActivationDeactivationUser(0)
      dispatch(getUsers(userId, showTrashUsers))
    }
  }, [activateDeactivateSuccess, activationDeactivationUser, userId])

  useEffect(() => {
    if (trashDone) {
      dispatch(getUsers(userId, showTrashUsers))
      dispatch(sendUserToTrashClean())
    }
  }, [trashDone, userId])

  useEffect(() => {
    if (restoreDone) {
      dispatch(getUsers(userId, showTrashUsers))
      dispatch(restoreUserClean())
    }
  }, [restoreDone, userId])

  const getPassword = () => {
    return passwordView ? user.password : "************"
  }

  const [modalPasswordResetBackdrop, setModalPasswordResetBackdrop] =
    useState(false)

  const [
    modalActivationDeactivationBackdrop,
    setModalActivationDeactivationBackdrop,
  ] = useState(false)

  const handleResetCourses = () => {
    dispatch(
      resetGroupUser({
        id: userForResetCourses,
      })
    )
    setUserForResetCourses(undefined)
  }

  const showDependientUsers = userId => {
    dispatch(getUser(userId))
    setDependients(true)
  }

  const trashDropdownActions = (cell, row, rowIndex, extraData) => {
    const active = extraData?.active ?? 0
    return (
      <Dropdown
        key={`dropdown-trash-${row.userId}`}
        isOpen={row.userId === active}
        toggle={() => {
          setDropDown(row.userId === active ? 0 : row.userId)
        }}
      >
        <DropdownToggle color="primary" className="btn btn-primary btn-md">
          Acciones <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="white-celf-background">
          <DropdownItem
            onClick={() => {
              setUntrash(row.userId)
            }}
          >
            Recuperar usuario
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }

  const dropDownActions = (cell, row, rowIndex, extraData) => {
    const active = extraData?.active ?? 0
    return (
      <Dropdown
        key={`dropdown-${row.userId}`}
        isOpen={row.userId === active}
        toggle={() => {
          setDropDown(row.userId === active ? 0 : row.userId)
        }}
      >
        <DropdownToggle color="primary" className="btn btn-primary btn-md">
          Acciones <i className="mdi mdi-chevron-down" />
        </DropdownToggle>
        <DropdownMenu className="white-celf-background">
          <DropdownItem>
            <Link to={`/start/adm-usuarios/edit/${row.userId}`}>Editar</Link>
          </DropdownItem>
          <DropdownItem onClick={() => resetPassword(row)}>
            Resetear contraseña
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              setActivationType(!row.status)
              setActivationDeactivationUser(row.userId)
              setModalActivationDeactivationBackdrop(true)
            }}
          >
            {row.status ? "Desactivar" : "Activar"}
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              setTrash(row.userId)
            }}
          >
            Enviar a papelera
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  }

  const columns = useMemo(() => {
    const cols = [
      {
        dataField: "userId",
        text: "Id",
        sort: false,
        hidden: true,
      },
      {
        dataField: "firstName",
        text: "Nombre completo y correo",
        sort: true,
        // eslint-disable-next-line react/display-name
        formatter: (column, row) => {
          return (
            <div key={`nombre-${row.userId}`}>
              <strong>
                <Link to={`/start/adm-usuarios/edit/${row.userId}`}>
                  {row.firstName} {row.lastName}
                </Link>
              </strong>
              <br />
              <span>{row.email}</span>
            </div>
          )
        },
        csvFormatter: (column, row) => `${row.firstName} ${row.lastName}`,
      },
      {
        dataField: "lastName",
        text: "Apellido",
        sort: true,
        csvExport: false,
        hidden: true,
      },
      {
        dataField: "email",
        text: "Email",
        sort: true,
        csvExport: true,
        hidden: true,
      },
      {
        dataField: "profileId",
        text: "Capacitación Fester",
        sort: true,
        csvExport: true,
        hidden: false,
        // eslint-disable-next-line react/display-name
        formatter: (cell, row, rowIndex, extraData) => {
          return row.profileId === 9 ? <span>No</span> : <span>Sí / N{row.profileId}</span>
        },
      },
      {
        dataField: "cmoProfileId",
        text: "Certificaciones CMO",
        sort: true,
        csvExport: true,
        hidden: false,
        // eslint-disable-next-line react/display-name
        formatter: (cell, row, rowIndex, extraData) => {
          const isCmo = row.cmoProfileId ?? 0
          return isCmo === 0 ? <span>No</span> : <span>Sí / N{isCmo}</span>
        },
        sortFunc: (a, b, order, dataField, rowA, rowB) => {
          const profileA = rowA.cmoProfileId
            ? rowA.cmoProfileId
            : 0
          const profileB = rowB.cmoProfileId
            ? rowB.cmoProfileId
            : 0

          if (order === "asc") {
            return profileB > profileA ? -1 : 1
          }
          return profileB > profileA ? 1 : -1
        },
      },
      {
        dataField: "softskillsProfileId",
        text: "Soft Skills",
        sort: true,
        csvExport: true,
        hidden: false,
        // eslint-disable-next-line react/display-name
        formatter: (cell, row, rowIndex, extraData) => {
          return (
            <span>
              {row.softskillsProfileId
                ? `Sí (${getSoftskillsProfileName(row.softskillsProfileId)})`
                : "No"}
            </span>
          )
        },
        sortFunc: (a, b, order, dataField, rowA, rowB) => {
          const stringA = rowA.softskillsProfileId
            ? getSoftskillsProfileName(rowA.softskillsProfileId)
            : "No"
          const stringB = rowB.softskillsProfileId
            ? getSoftskillsProfileName(rowB.softskillsProfileId)
            : "No"

          if (order === "asc") {
            return stringB > stringA ? -1 : 1
          }
          return stringB > stringA ? 1 : -1
        },
      },
      {
        dataField: "status",
        text: "Estatus",
        sort: true,
        align: "center",
        CSVExport: false,
        // eslint-disable-next-line react/display-name
        formatter: (cell, row, rowIndex, extraData) => {
          return (
            <h4 style={{ marginBottom: 0 }} key={`status-${row.status}`}>
              <span
                className={`pt-2 badge bg-${row.status ? "success" : "warning"}`}
              >
                {row.status ? "Activo" : "Inactivo"}
              </span>
            </h4>
          )
        },
        csvFormatter: (column, row) => (row.status ? "Activo" : "Inactivo"),
      },
      {
        dataField: "lastActivity",
        text: "Último ingreso",
        csvText: "Último ingreso",
        sort: true,
        align: "center",
        CSVExport: false,
        // eslint-disable-next-line react/display-name
        formatter: (column, row) => {
          return row.aceptotyc !== null && row.aceptoPrivacidadDatos !== null ? (
            <span key={`time-${row.idUsuario}`}>
              {moment(row.lastActivity)
                .locale("es")
                .format("DD/MM/YYYY HH:mm [hrs.]")}
            </span>
          ) : (
            <span>-</span>
          )
        },
        csvFormatter: (column, row) =>
          moment(row.lastActivity).format("D/M/YYYY HH:mm [hrs.]"),
      },
    ]

    if (profileId <= 7) {
      cols.push({
        dataField: "actions",
        text: "Acciones",
        sort: false,
        csvExport: false,
        formatter: showTrashUsers ? trashDropdownActions : dropDownActions,
        formatExtraData: {
          active: dropDown,
        },
      })
    }

    return cols
  }, [profileId, dropDown])

  const pageOptions = {
    sizePerPage: sizePerPage === undefined ? 10 : sizePerPage,
    totalSize: filteredUsers.length,
    custom: true,
    showTotal: true,
    page: page === undefined ? 1 : page,
    onPageChange: page => {
      setPage(page)
    },
    onSizePerPageChange: sizePerPage => {
      setSizePerPage(sizePerPage)
    },
  }

  const getXlsData = users => {
    let data = users.map((user, index) => {
      return {
        ID: user.userId,
        "Nombre completo": `${user.firstName} ${user.lastName}`,
        Correo: user.email,
        Cliente: user.nombreCliente === null ? "-" : user.clientName,
        Grupo: user.groupId === null ? "Ninguno" : user.groupName,
        "Último ingreso":
          user.aceptotyc !== null && user.aceptoPrivacidadDatos !== null
            ? moment(user.lastActivity).format("D/M/YYYY HH:mm [hrs.]")
            : "-",
        Perfil: `N${user.profileId}`,
        Estatus: user.status ? "Activo" : "Inactivo",
      }
    })

    return {
      Usuarios: data,
    }
  }

  const defaultSorted = useMemo(() => [{ dataField: "profileId", order: "asc" }], [])

  const handleSearchChange = useCallback(e => {
    const value = e.target.value
    setSearchText(value)
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
    debounceRef.current = setTimeout(() => {
      if (toolkitSearchRef.current) {
        toolkitSearchRef.current.onSearch(value)
        setPage(1)
      }
    }, 350)
  }, [])

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
    }
  }, [])

  const resetPassword = user => {
    setModalPasswordResetBackdrop(true)
    setUser(user)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  return loading && users === undefined ? (
    <div className="mt-3 mb-3">
      <div className="spinner-chase">
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
      </div>
    </div>
  ) : (
    <Fragment>
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="userId"
        columns={columns}
        data={users}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="userId"
            columns={columns}
            data={users}
            search={{
              afterSearch: newData => {
                setFilteredUsers(newData)
              },
            }}
          >
            {toolkitProps => {
              toolkitSearchRef.current = toolkitProps.searchProps
              return (
              <React.Fragment>
                <Row className="mb-2 pt-3">
                  <Col lg={2} md={3} sm={4} xs={4}>
                    <div className="d-grid">
                      <Link
                        to="/start/adm-usuarios/add"
                        className="btn btn-primary btn-rounded"
                      >
                        <i className="fa fa-plus"></i> Agregar usuario
                      </Link>
                    </div>
                  </Col>
                  <Col lg={2} md={3} sm={4} xs={4}>
                    <div className="d-grid">
                      <Button 
                        className="btn btn-secondary btn-rounded"
                        onClick={() => setShowTrashUsers(!showTrashUsers)}
                      >
                        <i className={`fa ${showTrashUsers ? "fa-eye" : "fa-trash"}`}></i> Mostrar {showTrashUsers ? "activos" : "papelera"}
                      </Button>
                    </div>
                  </Col>
                  <Col
                    lg={6}
                    md={3}
                    sm={0}
                    xs={0}
                    className="text-center"
                  ></Col>
                  <Col
                    lg={{ size: 2 }}
                    md={{ size: 3 }}
                    sm={{ size: 4 }}
                    xs={4}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <input
                          className="form-control"
                          placeholder="Buscar"
                          type="text"
                          value={searchText}
                          onChange={handleSearchChange}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                {users !== undefined && filteredUsers !== undefined && (
                  <Row>
                    <Col xs={8}>
                      <p>
                        {filteredUsers.length === users.length ? (
                          <span>
                            Mostrando{" "}
                            <strong>{numberWithCommas(users.length)}</strong>{" "}
                            usuarios
                          </span>
                        ) : (
                          <span>
                            Mostrando{" "}
                            <strong>
                              {numberWithCommas(filteredUsers.length)}
                            </strong>{" "}
                            usuarios de un total de{" "}
                            <strong>{numberWithCommas(users.length)}</strong>
                          </span>
                        )}
                      </p>
                    </Col>
                    <Col xs={4} className="d-flex justify-content-end pr-4">
                      <XlsExporter
                        data={getXlsData(filteredUsers)}
                        dataName={"Usuarios"}
                        name="Usuarios"
                        label="Exportar lista"
                      />
                    </Col>
                  </Row>
                )}

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <Fragment>
                        <BootstrapTable
                          keyField={"userId"}
                          bordered={false}
                          striped={true}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                        {users?.length <= 0 && (
                          <Row>
                            <Col md={12} className="text-center">
                              -- No hay registros --
                            </Col>
                          </Row>
                        )}
                      </Fragment>
                    </div>
                  </Col>
                </Row>
                <RestorePasswordModal
                  show={modalPasswordResetBackdrop}
                  error={
                    changePasswordError != ""
                      ? changePasswordError
                      : forgetError
                  }
                  onCancel={() => {
                    setModalPasswordResetBackdrop(false)
                    dispatch(userForgetPasswordClean())
                  }}
                  onConfirmWithLink={() => {
                    dispatch(userForgetPassword(user.email, true))
                  }}
                  onConfirmWithPassword={password => {
                    setUser({
                      ...user,
                      password: password,
                    })
                    dispatch(changePassword(user.userId, password, userId))
                  }}
                />
                {activateDeactivateSuccess && (
                  <SweetAlert
                    title={`Usuario ${
                      activationType ? "activado" : "inactivado"
                    }`}
                    success
                    confirmBtnBsStyle="success"
                    onConfirm={() => {
                      dispatch(activateDeactivateClean())
                      setActivationType(undefined)
                    }}
                  >
                    Se le ha enviado un correo al usuario indicándole que ha
                    sido {activationType ? "activado" : "inactivado"} en la
                    plataforma.
                  </SweetAlert>
                )}
                {forgetPasswordSent && (
                  <SweetAlert
                    title="Correo enviado"
                    success
                    confirmBtnBsStyle="success"
                    onConfirm={() => {
                      setModalPasswordResetBackdrop(false)
                      setForgetPasswordSent(false)
                      setUser({})
                    }}
                  >
                    Enviamos a {user.firstName} un correo con las instrucciones
                    para restaurar su contraseña.
                  </SweetAlert>
                )}
                {changePasswordSent && (
                  <SweetAlert
                    title="Contraseña modificada"
                    success
                    confirmBtnBsStyle="success"
                    onConfirm={() => {
                      setModalPasswordResetBackdrop(false)
                      setChangePasswordSent(false)
                      setUser({})
                    }}
                  >
                    <p>
                      La contraseña de {user.firstName} ha sido modificada
                      exitosamente.
                    </p>
                    {/*<p>
                    Contraseña:
                    {getPassword()}
                    <button
                      className="btn btn-link"
                      onClick={setPasswordView(!passwordView)}
                    >
                      <i
                        className={`fa fa-${
                          passwordView ? "eye-show" : "eye-hide"
                        }`}
                      ></i>
                    </button>
                      </p>*/}
                  </SweetAlert>
                )}
                <ActivationDeactivationModal
                                    onCancel={() =>
                                      setModalActivationDeactivationBackdrop(false)
                                    }
                                    onConfirm={() => {
                                      dispatch(
                                        activateDeactivate(
                                          activationDeactivationUser,
                                          activationType,
                                          userId
                                        )
                                      )
                                      setModalActivationDeactivationBackdrop(false)
                                    }}
                                    action={activationType}
                                    show={modalActivationDeactivationBackdrop}
                                  />                                
                                {activateDeactivateSuccess && (
                                  <SweetAlert
                                    title={`Usuario ${
                                      activationType ? "activado" : "inactivado"
                                    }`}
                                    success
                                    confirmBtnBsStyle="success"
                                    onConfirm={() => {
                                      dispatch(activateDeactivateClean())
                                      setActivationType(undefined)
                                    }}
                                  >
                                    Se le ha enviado un correo al usuario indicándole que ha
                                    sido {activationType ? "activado" : "inactivado"} en la
                                    plataforma.
                                  </SweetAlert>
                                )}

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}}
          </ToolkitProvider>
        )}
      </PaginationProvider>
      {userForResetCourses !== undefined && (
        <SweetAlert
          title="Resetear cursos"
          warning
          confirmBtnBsStyle="secondary"
          confirmBtnText="Sí"
          onConfirm={handleResetCourses}
          showCancel={true}
          cancelBtnBsStyle="light"
          cancelBtnText="No"
          onCancel={() => setUserForResetCourses(undefined)}
        >
          <p>¿Confirmas el reseteo de todos los cursos del participante?</p>
        </SweetAlert>
      )}
      {trash !== undefined && (
        <SweetAlert
          title="Enviar a papelera"
          warning
          confirmBtnBsStyle="danger"
          confirmBtnText="Sí, enviar"
          showCancel={true}
          cancelBtnBsStyle="light"
          cancelBtnText="No, cancelar"
          onConfirm={() => {
            dispatch(sendUserToTrash(trash))
            setTrash(undefined)
          }}
          onCancel={() => {
            setTrash(undefined)
          }}
        >
          <p>¿Confirmas que deseas enviar a este usuario a papelera?</p>
        </SweetAlert>
      )}
      {untrash !== undefined && (
        <SweetAlert
          title="Restaurar usuario"
          warning
          confirmBtnBsStyle="danger"
          confirmBtnText="Sí, restaurar"
          showCancel={true}
          cancelBtnBsStyle="light"
          cancelBtnText="No, cancelar"
          onConfirm={() => {
            dispatch(restoreUser(untrash))
            setUntrash(undefined)
          }}
          onCancel={() => {
            setUntrash(undefined)
          }}
        >
          <p>¿Confirmas que deseas restaurar a este usuario?</p>
        </SweetAlert>
      )}
    </Fragment>
  )
}

HubUsersListTable.propTypes = {
  users: PropTypes.array,
  onUpdateStatus: PropTypes.func,
}

export default HubUsersListTable
